var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"dropdown-item",attrs:{"href":_vm.link},on:{"click":function($event){$event.preventDefault();return _vm.destroy.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-trash-o fa-fw"}),_vm._v(" Remover")])
}
var staticRenderFns = []

export { render, staticRenderFns }